"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[52506],{

/***/ 879779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ BackToTop; }
/* harmony export */ });
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(994734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);




const BackToTop = ({
  position,
  zIndex,
  pageYOffset,
  className
}) => {
  const [show, setShow] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!pageYOffset);
  const scrollToTop = () => {
    if (typeof window !== "undefined")
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
  };
  const checkScrollTop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (typeof window !== "undefined") {
      if (!show && window.pageYOffset > pageYOffset) {
        setShow(true);
      } else if (show && window.pageYOffset <= pageYOffset) {
        setShow(false);
      }
    }
  }, [show]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (typeof window !== "undefined")
      window.addEventListener("scroll", checkScrollTop);
    return () => {
      if (typeof window !== "undefined")
        window.removeEventListener("scroll", checkScrollTop);
    };
  }, [show]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBackToTop, {
    position,
    zIndex,
    show,
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ScrollToTopBtn, {
    onClick: scrollToTop
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__/* .UpOutlined */ .X, {
    size: 24,
    color: "primary"
  })));
};
const StyledBackToTop = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ show, zIndex, position, theme }) => `
  display: ${show ? "block" : "none"};
  z-index: ${zIndex ? zIndex : 1030};
  position: fixed;
  ${position ? `
    ${position.bottom ? `bottom: ${position.bottom}rem;` : ""}
    ${position.top ? `top: ${position.top}rem;` : ""}
    ${position.left ? `left: ${position.left}rem;` : ""}
    ${position.right ? `right: ${position.right}rem;` : ""}
  ` : ""}
  cursor: pointer;
  animation: fadeIn 0.3s;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  &:hover {
    path[stroke],
    rect[stroke],
    line {
      stroke: ${theme == null ? void 0 : theme.colors.textSecondary};
    }
    path:not([stroke]),
    rect:not([stroke]) {
      fill: ${theme == null ? void 0 : theme.colors.textSecondary};
    }
  }
`);
const ScrollToTopBtn = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ theme }) => `
  border-radius: 50%;
  background-color: ${theme == null ? void 0 : theme.colors.primary100};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  height: 3rem;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
`);




/***/ }),

/***/ 613295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(621655);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const BadgeWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: relative;
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
`;
const StyledBadge = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ theme, top, right, color }) => `
  min-width: ${theme == null ? void 0 : theme.spacing.s16};
  height: ${theme == null ? void 0 : theme.spacing.s16};
  padding: ${theme == null ? void 0 : theme.spacing.s0} ${theme == null ? void 0 : theme.spacing.s4};
  background: ${color ? color : theme == null ? void 0 : theme.colors.error500};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: ${top ? typeof top === "number" ? `${top}px` : top : 0};
  right: ${right ? typeof right === "number" ? `${right}px` : right : 0};
  transform: translate(50%,-50%);
  transform-origin: 100% 0;
`);
const StyledCaption = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS)`
  text-align: center;
`;
const Badge = (_a) => {
  var _b = _a, {
    count,
    offset,
    overflowCount = 99,
    showZero = false,
    color,
    children
  } = _b, rest = __objRest(_b, [
    "count",
    "offset",
    "overflowCount",
    "showZero",
    "color",
    "children"
  ]);
  const displayCount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    return count < 0 ? 0 : overflowCount && count > overflowCount ? `${overflowCount}+` : count;
  }, [count, overflowCount]);
  const [top, right] = offset ? offset : [];
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BadgeWrapper, __spreadValues({}, rest), children, (count > 0 || count === 0 && showZero) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBadge, {
    top,
    right,
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCaption, {
    level: 3,
    color: "white"
  }, displayCount)));
};




/***/ }),

/***/ 222056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Chip; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(944912);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(252661);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAPPING_HEIGHT = {
  m: 24,
  l: 32
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
  display: inline-flex;
  align-items: center;
  padding-left: ${(p) => p.theme.spacing.s12};
  padding-right: ${(p) => p.theme.spacing.s12};
  background-color: ${(p) => p.theme.colors.white};
  height: ${(p) => MAPPING_HEIGHT[p.size]}px;
  border-radius: 1.5rem;
  border: ${(p) => p.theme.borderWeight.m} solid
    ${(p) => p.theme.colors.disable};
  ${(p) => p.disabled ? "cursor: not-allowed;" : `
  `}
`;
const Chip = (_a) => {
  var _b = _a, {
    content,
    size = "m",
    closable,
    closeIcon,
    disabled = false,
    onClose = () => {
    },
    onClick
  } = _b, props = __objRest(_b, [
    "content",
    "size",
    "closable",
    "closeIcon",
    "disabled",
    "onClose",
    "onClick"
  ]);
  const getColorCloseIcon = () => {
    var _a2;
    if (!closable || closeIcon || (0,_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .hasColoredIcon */ .e)(closeIcon))
      return void 0;
    if (disabled)
      return "disabled";
    if (!((_a2 = closeIcon == null ? void 0 : closeIcon.props) == null ? void 0 : _a2.color))
      return "placeholder";
    return closeIcon.props.color;
  };
  const renderClose = () => {
    var _a2, _b2;
    if (!closable)
      return null;
    return closeIcon ? react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(closeIcon, {
      size: !((_a2 = closeIcon == null ? void 0 : closeIcon.props) == null ? void 0 : _a2.size) ? 16 : closeIcon.props.size,
      color: getColorCloseIcon(),
      onClick: (e) => !disabled && onClose(e),
      style: __spreadProps(__spreadValues({}, (_b2 = closeIcon == null ? void 0 : closeIcon.props) == null ? void 0 : _b2.style), {
        cursor: disabled ? "not-allowed" : "pointer"
      })
    }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .DeleteCircleFilled */ .N, {
      color: disabled ? "disable" : "placeholder",
      size: 16,
      style: { cursor: disabled ? "not-allowed" : "pointer" },
      onClick: (e) => !disabled && onClose(e)
    });
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    onClick: () => {
      !disabled && onClick && onClick();
    },
    size,
    disabled
  }, props), size === "l" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
    level: 1,
    weight: "regular",
    line: 1,
    color: disabled ? "disable" : "textPrimary",
    marginRight: closable ? "s8" : void 0
  }, content), renderClose()) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .Caption */ .YS, {
    level: 1,
    weight: "regular",
    line: 1,
    color: disabled ? "disable" : "textPrimary",
    marginRight: closable ? "s4" : void 0
  }, content), renderClose()));
};




/***/ }),

/***/ 952716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ Collapse; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(925810);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(994734);
/* harmony import */ var _Flex_Flex_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(387100);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





function Collapse({
  items = [],
  render,
  max = 3,
  showText,
  hideText
}) {
  const [itemToShow, setItemToShow] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(max);
  const children = render ? items.slice(0, itemToShow).map((item, index) => render(item, index)) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null);
  const showMore = () => setItemToShow(items.length);
  const showLess = () => setItemToShow(max);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Flex_Flex_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .k, {
    justify: "center"
  }, max >= items.length ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null) : itemToShow < items.length ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledFlexWrapper, {
    align: "center",
    gap: "s4",
    onClick: showMore
  }, showText, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .DownOutlined */ .T, {
    size: 14
  })) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledFlexWrapper, {
    align: "center",
    gap: "s4",
    onClick: showLess
  }, hideText, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .UpOutlined */ .X, {
    size: 14
  }))));
}
const StyledFlexWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_Flex_Flex_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .k)`
  cursor: pointer;
  background-color: unset;
  color: #82869e;
  border: 0px;
  &:focus {
    border: 0px;
    outline: 0px;
  }
`;




/***/ }),

/***/ 960340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Movable; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Shape_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(425336);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getTrackedTouch = (containerRef, touches) => Array.from(touches).find((touch) => {
  var _a;
  return (_a = containerRef.current) == null ? void 0 : _a.contains(touch.target);
});
const calculateShiftAmount = (clientX, clientY, leftBoundingRect, topBoundingRect) => ({
  shiftLeft: clientX - leftBoundingRect,
  shiftTop: clientY - topBoundingRect
});
const Movable = (_a) => {
  var _b = _a, {
    movable = true,
    children,
    boundingRect
  } = _b, rest = __objRest(_b, [
    "movable",
    "children",
    "boundingRect"
  ]);
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const shiftLeft = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
  const shiftTop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
  const isServerless = typeof window !== "undefined";
  const isTouchable = isServerless && "ontouchstart" in window;
  const startEvent = isTouchable ? "touchstart" : "mousedown";
  const moveEvent = isTouchable ? "touchmove" : "mousemove";
  const endEvent = isTouchable ? "touchend" : "mouseup";
  const move = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((clientX, clientY, shiftLeft2, shiftTop2) => {
    const el = ref.current;
    if (el) {
      const left = clientX - shiftLeft2;
      const top = clientY - shiftTop2;
      const right = document.documentElement.clientWidth - left - el.clientWidth;
      const bottom = document.documentElement.clientHeight - top - el.clientHeight;
      const {
        top: topRect = 0,
        left: leftRect = 0,
        right: rightRect = 0,
        bottom: bottomRect = 0
      } = boundingRect || {};
      let leftStyle = `${left < leftRect ? leftRect : left}px`;
      let topStyle = `${top < topRect ? topRect : top}px`;
      if (right < rightRect) {
        leftStyle = `${document.documentElement.clientWidth - rightRect - el.clientWidth}px`;
      }
      if (bottom < bottomRect) {
        topStyle = `${document.documentElement.clientHeight - bottomRect - el.clientHeight}px`;
      }
      el.style.left = leftStyle;
      el.style.top = topStyle;
    }
  }, [boundingRect]);
  const onMove = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((moveEvent2) => {
    if (ref.current) {
      moveEvent2.preventDefault();
      const el = ref.current;
      Array.from(el.children).forEach((child) => {
        child.style.pointerEvents = "none";
      });
      if (moveEvent2 instanceof TouchEvent) {
        const touch = getTrackedTouch(ref, moveEvent2.touches);
        if (!touch)
          return;
        move(touch == null ? void 0 : touch.clientX, touch == null ? void 0 : touch.clientY, shiftLeft.current, shiftTop.current);
      } else {
        el.onclick = null;
        move(moveEvent2 == null ? void 0 : moveEvent2.clientX, moveEvent2 == null ? void 0 : moveEvent2.clientY, shiftLeft.current, shiftTop.current);
      }
    }
  }, [move]);
  const onEnd = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (ref.current) {
      const el = ref.current;
      Array.from(el.children).forEach((child) => {
        child.style.pointerEvents = "auto";
      });
      document.removeEventListener(moveEvent, onMove);
      el.removeEventListener(endEvent, onEnd);
    }
  }, [onMove]);
  const onStart = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((startEvent2) => {
    if (ref.current) {
      const el = ref.current;
      const { left, top } = el.getBoundingClientRect();
      if (startEvent2 instanceof TouchEvent) {
        const touch = getTrackedTouch(ref, startEvent2.touches);
        if (!touch)
          return;
        ({ shiftLeft: shiftLeft.current, shiftTop: shiftTop.current } = calculateShiftAmount(touch.clientX, touch.clientY, left, top));
      } else {
        ({ shiftLeft: shiftLeft.current, shiftTop: shiftTop.current } = calculateShiftAmount(startEvent2.clientX, startEvent2.clientY, left, top));
      }
      document.addEventListener(moveEvent, onMove);
      el.addEventListener(endEvent, onEnd);
    }
  }, [onEnd, onMove]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const el = ref.current;
    el == null ? void 0 : el.addEventListener(startEvent, onStart);
    return () => {
      el == null ? void 0 : el.removeEventListener(startEvent, onStart);
      document.removeEventListener(moveEvent, onMove);
      el == null ? void 0 : el.removeEventListener(endEvent, onEnd);
    };
  }, [movable, onStart]);
  if (!isServerless)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    ref,
    onDragStart: () => false
  }, rest), children);
};
const Wrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b)((props) => `
  ${(0,_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .getDimension */ .L)(props.top || "", "top: ", ";")}
  ${(0,_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .getDimension */ .L)(props.bottom || "", "bottom: ", ";")}
  ${(0,_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .getDimension */ .L)(props.left || "", "left: ", ";")}
  ${(0,_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .getDimension */ .L)(props.right || "", "right: ", ";")}
  position: fixed;
  width: fit-content;
  height: fit-content;
  cursor: move;
  touch-action: none;
`);




/***/ }),

/***/ 603626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ InputSlider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(285212);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(640128);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const InputSlider = (_a) => {
  var _b = _a, {
    range,
    min = 0,
    max = 100,
    value,
    defaultValue,
    onChange,
    disabled,
    step = 1,
    ref,
    tipFormatter,
    size = _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.m */ .mO.m,
    color = "primary",
    tooltip = true,
    changeOn = "dragging"
  } = _b, props = __objRest(_b, [
    "range",
    "min",
    "max",
    "value",
    "defaultValue",
    "onChange",
    "disabled",
    "step",
    "ref",
    "tipFormatter",
    "size",
    "color",
    "tooltip",
    "changeOn"
  ]);
  var _a2, _b2, _c;
  const valueDefault = defaultValue ? defaultValue : range ? [min, max] : min;
  const valueSlider = value !== void 0 ? value : valueDefault;
  const innerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const trackFillRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const tooltipRefs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([null, null]);
  const thumbRefs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([null, null]);
  const mouseMoveEventRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const mouseUpEventRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const percents = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(getPercent(max, min, valueSlider));
  const currentPercent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const isDragging = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  const formatter = (value2) => {
    if (value2 === void 0)
      return "";
    if (tipFormatter)
      return tipFormatter(value2);
    return new Intl.NumberFormat("en-CA", {
      maximumFractionDigits: 10
    }).format(value2);
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => {
    document.removeEventListener("mousemove", mouseMoveEventRef.current || (() => {
    }));
    document.removeEventListener("mouseup", mouseUpEventRef.current || (() => {
    }));
    document.removeEventListener("touchmove", mouseMoveEventRef.current || (() => {
    }));
    document.removeEventListener("touchend", mouseUpEventRef.current || (() => {
    }));
  }, []);
  const clickInTrack = (e) => {
    var _a3;
    e.stopPropagation();
    const { pageX } = getPosition(e);
    const { left = 0, width } = ((_a3 = innerRef.current) == null ? void 0 : _a3.getBoundingClientRect()) || {};
    if (!width) {
      return;
    }
    const newValue = (Number(pageX || left) - left) / width * 100;
    const [currentLeft, currentRight] = percents.current;
    const [deltaLeft, deltaRight] = [
      newValue - currentLeft,
      currentRight - newValue
    ];
    const activeIndex = range && deltaLeft < deltaRight ? 0 : 1;
    setPositions(pageX, activeIndex);
    setTooltipVisible(activeIndex, "visible");
    changeValue();
  };
  const onStartMove = (e, index) => {
    e.stopPropagation();
    currentPercent.current = percents.current[index];
    const onMouseMove = (event) => {
      isDragging.current = true;
      const { pageX: moveX } = getPosition(event);
      setPositions(moveX, index);
    };
    const onMouseUp = () => {
      setTooltipVisible(index, "hidden");
      document.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("touchend", onMouseUp);
      document.removeEventListener("touchmove", onMouseMove);
      changeOn === "dragend" && changeValue();
      mouseMoveEventRef.current = null;
      mouseUpEventRef.current = null;
      isDragging.current = false;
      currentPercent.current = null;
    };
    document.addEventListener("mouseup", onMouseUp);
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("touchend", onMouseUp);
    document.addEventListener("touchmove", onMouseMove);
    mouseMoveEventRef.current = onMouseMove;
    mouseUpEventRef.current = onMouseUp;
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (percents.current === void 0 || valueSlider === void 0)
      return;
    const [leftPercent, rightPercent] = getPercent(max, min, valueSlider);
    if (percents.current[0] === leftPercent && percents.current[1] === rightPercent) {
      return;
    }
    percents.current = [leftPercent, rightPercent];
    determinePosition(rightPercent - leftPercent, leftPercent);
  }, [valueSlider.toString(), max, min, range]);
  const getValue = (percent) => {
    const value2 = percent * (max - min) / 100;
    const v = Math.round(value2 / step) * step;
    const displayValue = Math.round(v * 100) / 100 + min;
    return displayValue > max ? max : displayValue;
  };
  const setPositions = (pageX = 0, index = null) => {
    var _a3;
    const { left = 0, width } = ((_a3 = innerRef.current) == null ? void 0 : _a3.getBoundingClientRect()) || {};
    if (!width) {
      return;
    }
    const newValue = (Number(pageX || left) - left) / width * 100;
    changePercent(newValue, index);
    changeOn === "dragging" && changeValue();
  };
  const determinePosition = (percent, leftPercent) => {
    if (trackFillRef.current) {
      trackFillRef.current.style.width = `${percent}%`;
      trackFillRef.current.style.left = `${leftPercent}%`;
    }
    if (thumbRefs.current && tooltipRefs.current) {
      percents.current.forEach((pos, index) => {
        if (thumbRefs.current[index]) {
          thumbRefs.current[index].style.left = `calc(${pos}% ${pos === 100 ? `- ${sizes[size].thumb / 2}px` : ""})`;
        }
        if (tooltipRefs.current[index]) {
          tooltipRefs.current[index].innerText = formatter(getValue(pos));
        }
      });
    }
  };
  const changeValue = () => {
    const [_left, _right] = percents.current;
    const newValues = [getValue(_left), getValue(_right)];
    if (newValues.toString() === valueSlider.toString())
      return;
    onChange == null ? void 0 : onChange(range ? newValues : newValues[1]);
  };
  const changePercent = (value2, index = null) => {
    let newValue = value2;
    const ltr = newValue - (currentPercent.current || 0) > 0;
    if (percents.current) {
      let [thumbLeft, thumbRight] = percents.current;
      if (ltr && getValue(newValue) > getValue(thumbRight) && index === 0) {
        return;
      }
      if (!ltr && getValue(newValue) < getValue(thumbLeft) && index === 1) {
        return;
      }
      if (newValue >= 100) {
        newValue = 100;
      }
      if (newValue <= 0) {
        newValue = 0;
      }
      if (index === null) {
        const middle = (thumbLeft + thumbRight) / 2;
        currentPercent.current = newValue;
        if (newValue > middle || !range) {
          thumbRight = newValue;
        } else {
          thumbLeft = newValue;
        }
        percents.current = [thumbLeft, thumbRight];
      } else {
        percents.current[index] = newValue;
      }
      const [_left, _right] = percents.current;
      const percent = _right - _left;
      determinePosition(percent, _left);
    }
  };
  const setTooltipVisible = (index, value2) => {
    if (tooltipRefs.current[index])
      tooltipRefs.current[index].style.visibility = value2;
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SliderWrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    ref: innerRef,
    size,
    color,
    onMouseDown: clickInTrack
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SliderTrack, {
    className: "slider-track"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SliderTrackFill, {
    className: "slider-track-fill",
    ref: trackFillRef,
    style: {
      width: `${((_a2 = percents.current) == null ? void 0 : _a2[1]) - ((_b2 = percents.current) == null ? void 0 : _b2[0])}%`,
      left: `${(_c = percents.current) == null ? void 0 : _c[0]}%`
    }
  })), [...Array(2)].map((_, index) => {
    var _a3;
    return !range && index == 0 ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StylerThumb, {
      key: index,
      className: "slider-thumb",
      ref: (e) => {
        thumbRefs.current[index] = e;
      },
      style: {
        left: `${(_a3 = percents.current) == null ? void 0 : _a3[index]}%`
      },
      onMouseDown: (e) => onStartMove(e, index),
      onTouchStart: (e) => onStartMove(e, index),
      onMouseMove: () => !isDragging.current && setTooltipVisible(index, "visible"),
      onTouchMove: () => !isDragging.current && setTooltipVisible(index, "visible"),
      onMouseOut: () => !isDragging.current && setTooltipVisible(index, "hidden"),
      onTouchCancel: () => !isDragging.current && setTooltipVisible(index, "hidden"),
      role: "slider"
    }, tooltip && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyleTooltip, {
      className: "tooltip",
      ref: (e) => tooltipRefs.current[index] = e
    }, formatter(getValue(percents.current[index]))));
  })));
};
InputSlider.displayName = "InputSlider";
const SliderWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F};
  padding: 0.5rem 0;
`;
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div(({ theme, size, color }) => `
  position: relative;
  height: ${sizes[size || _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.m */ .mO.m].height}px;
  width: 100%;

  & >.slider-track .slider-track-fill {
     background-color: ${theme.colors[color] || color};
  }

  & >.slider-thumb{
    box-shadow: 0px 0px 0px 1.5px ${theme.colors[color] || color} inset;
    width: ${sizes[size || _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.m */ .mO.m].thumb}px;
    height:  ${sizes[size || _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.m */ .mO.m].thumb}px;
  }
`);
const SliderTrack = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  position: relative;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background};
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
`;
const SliderTrackFill = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  position: absolute;
  top: 0;
  height: 100%;
`;
const StylerThumb = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div(({ theme }) => `
  position: absolute;
  border-radius: 1000px;
  top: 0;
  transform: translate(-25%, -50%);
  background-color: ${theme.colors.white};
  text-align: center;
  cursor: pointer;
  top: 50%
`);
const StyleTooltip = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].span(({ theme }) => `
  visibility: hidden;
  background-color: ${theme.colors.black};
  color: #fff;
  text-align: center;
  padding: 2px 3px;
  position: absolute;
  z-index: 1;
  font-size: 0.625rem;
  border-radius: 3px;
  transform: translate(-50%, -150%);
  min-width: 1.25rem;
  user-select: none;
  // arrow
  &:after {
    content: '';
    width: 8px;
    height: 5px;
    bottom: -5px;
    border-top: 4px solid ${theme.colors.black};
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
  }
`);
const sizes = {
  xs: {
    height: 3,
    thumb: 9
  },
  s: {
    height: 4,
    thumb: 11
  },
  m: { height: 5, thumb: 12 },
  l: { height: 7, thumb: 15 },
  xl: { height: 4, thumb: 20 }
};
function getPosition(e) {
  const obj = "touches" in e ? e.touches[0] : e;
  return { pageX: obj.pageX, pageY: obj.pageY };
}
const getPercent = (max, min, valueSlider) => {
  let leftValue = min, rightValue = max;
  if (typeof valueSlider === "number") {
    rightValue = valueSlider;
  } else {
    [leftValue, rightValue] = valueSlider;
  }
  let [leftPercent, rightPercent] = [
    (leftValue - min) / (max - min) * 100,
    (rightValue - min) / (max - min) * 100
  ];
  if (leftPercent < 0 || leftPercent == void 0)
    leftPercent = 0;
  if (rightPercent > 100 || rightPercent == void 0)
    rightPercent = 100;
  return [leftPercent, rightPercent];
};




/***/ }),

/***/ 126083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ Label; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);


const StyledLabel = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"].label([
  ({ size, weight }) => `
  display: inline-block;
  font-size: ${labelSize[size || "m"]};
  font-weight: ${weight === "bold" ? "500" : "normal"};
  margin-bottom: 4px;
`,
  ({ required, requiredPosition }) => `
  ${required ? requiredPosition === "right" ? `
        :after {
          content: "*";
          color: #eb2101;
          display: inline-block;
          margin-left: 4px;
          font-size: 14px;
          line-height: 1;
        }` : `
        :before {
          content: "*";
          color: #eb2101;
          display: inline-block;
          margin-right: 4px;
          font-size: 14px;
          line-height: 1;
        }` : ""}`
]);
const Label = StyledLabel;
Label.defaultProps = {
  size: "m",
  weight: "normal",
  requiredPosition: "right"
};
const labelSize = {
  s: "12px",
  m: "15px",
  l: "18px"
};




/***/ }),

/***/ 997195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ LegacyInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(379126);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAX_PRICE = 1e11;
const StyledInput = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].input(({ error, allowClear, prefixIcon, disabled, theme: { colors } }) => `
    //Remove input shadow on IOS Safari
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    box-sizing: border-box;
    margin: 0;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: 'tnum';
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    padding: 4px 10px;
    color: ${colors.text};
    font-size: 14px;
    line-height: 1.5715;
    background-image: none;
    border: 1px solid
      ${!!error ? colors.error : colors.border} !important;
    border-radius: 4px;
    transition: all 0.3s;
    ${allowClear ? "padding-right: 32px" : ""};
    ${prefixIcon ? "padding-left: 36px" : ""};
    ${!disabled ? "background-color: #fff" : ""};

    &:hover {
      border-color: ${!!error ? colors.error : "#40a9ff"};
    }

    &:focus {
      border-color: ${!!error ? colors.error : "#40a9ff"};
      border-right-width: 1px !important;
      outline: 0;
      box-shadow: 0 0 0 2px
        ${!!error ? "rgba(255,77,79,.2)" : "rgba(24, 144, 255, 0.2)"};
    }
  `);
const InputContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: relative;
`;
const ClearIcon = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__/* .DeleteCircleColored */ .H)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.75rem;
  width: 1.25rem;
  height: 1.25rem;
`;
const Label = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].label(({ required, theme }) => `
    margin-bottom: 0.4rem;
    font-weight: 500;
    &::before {
      content: '*';
      display: ${required ? "inline-block" : "none"};
      margin-right: 4px;
      color: ${theme == null ? void 0 : theme.colors.error};
      font-size: 14px;
      width: max-content;
    }
  `);
const Error2 = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ theme }) => `
    padding-top: 0;
    color: ${theme == null ? void 0 : theme.colors.error500};
    font-size: 0.75rem;
    line-height: 1rem;
    transition: color 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    margin-top: 0.5rem;
  `);
const Currency = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.75rem;
`;
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  margin-bottom: 1rem;
`;
function resolveOnChange(target, e, onChange) {
  if (onChange) {
    let event = e;
    if (e.type === "click") {
      event = Object.create(e);
      event.target = target;
      event.currentTarget = target;
      const originalInputValue = target.value;
      target.value = "";
      onChange(event);
      target.value = originalInputValue;
      return;
    }
    onChange(event);
  }
}
const formatCurrency = (money) => {
  return money ? money.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") : `${money}`;
};
const LegacyInput = (_a) => {
  var _b = _a, {
    value,
    allowClear = true,
    label,
    required,
    error,
    name,
    prefixIcon,
    isFocused,
    allowFocus,
    inputType,
    currency,
    className,
    onChange
  } = _b, restProps = __objRest(_b, [
    "value",
    "allowClear",
    "label",
    "required",
    "error",
    "name",
    "prefixIcon",
    "isFocused",
    "allowFocus",
    "inputType",
    "currency",
    "className",
    "onChange"
  ]);
  const [internalValue, setInternalValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
  const textInputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (inputType === "price") {
      setInternalValue(formatCurrency(String(value)));
    } else {
      setInternalValue(value);
    }
  }, [value]);
  const handlePriceInput = (value2) => {
    value2 = value2.replace(/\./g, "");
    if (/^\d*$/.test(value2))
      return value2;
    return null;
  };
  const handleChange = (e) => {
    let value2 = e.target.value;
    if (inputType === "price") {
      value2 = handlePriceInput(value2);
      if (value2 !== null && textInputRef.current !== null) {
        if (Number(value2) > MAX_PRICE) {
          value2 = String(MAX_PRICE);
        }
        e.target.value = value2;
        resolveOnChange(textInputRef.current, e, onChange);
      }
    } else {
      if (textInputRef.current !== null) {
        setInternalValue(value2);
        resolveOnChange(textInputRef.current, e, onChange);
      }
    }
  };
  const handleClear = (e) => {
    if (textInputRef.current) {
      setInternalValue("");
      textInputRef.current.focus();
      resolveOnChange(textInputRef.current, e, onChange);
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (textInputRef.current && isFocused) {
      textInputRef.current.focus();
    }
  }, [isFocused]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    className
  }, label && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, {
    className: "input__label",
    required
  }, label), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputContainer, null, prefixIcon, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, __spreadProps(__spreadValues({
    name,
    label,
    value: internalValue,
    allowClear,
    onChange: handleChange,
    ref: textInputRef,
    error,
    prefixIcon,
    required
  }, restProps), {
    className: "input__input"
  })), allowClear && !!internalValue && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ClearIcon, {
    onClick: handleClear,
    size: 20,
    cursor: "pointer"
  }), !!currency && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Currency, null, currency)), !!error && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Error2, {
    className: "input__error"
  }, error));
};




/***/ }),

/***/ 812809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Popover; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var react_popper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(281668);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(621655);
/* harmony import */ var _style_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(540999);
/* harmony import */ var _utils_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82389);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _Button_Button_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(806748);








var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledBottom = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ buttonAlign }) => `
  display: flex;
  justify-content: ${buttonAlign || "end"};
  margin-top: 0.75rem;
`);
const StyledButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z)`
  .button-text {
    color: ${({ theme }) => theme == null ? void 0 : theme.colors.white};
  }
`;
const Popover = (_a) => {
  var _b = _a, {
    children,
    placement = "auto",
    title,
    content,
    show = true,
    buttonText,
    onClickButton,
    showArrow = true,
    buttonAlign,
    buttonVariant = "default"
  } = _b, rest = __objRest(_b, [
    "children",
    "placement",
    "title",
    "content",
    "show",
    "buttonText",
    "onClickButton",
    "showArrow",
    "buttonAlign",
    "buttonVariant"
  ]);
  const elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const tooltipRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const arrowRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const { styles, attributes } = (0,react_popper__WEBPACK_IMPORTED_MODULE_3__/* .usePopper */ .D)(elementRef.current, tooltipRef.current, {
    placement,
    modifiers: [
      {
        name: "arrow",
        options: { element: arrowRef.current }
      },
      {
        name: "offset",
        options: {
          offset: [0, 8]
        }
      }
    ]
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: { display: "flex" },
    ref: elementRef
  }, children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_style_es_js__WEBPACK_IMPORTED_MODULE_4__/* .PopoverWrapper */ .DD, __spreadValues(__spreadValues({
    ref: tooltipRef,
    style: __spreadValues({}, styles.popper),
    visibility: show
  }, attributes.popper), rest), showArrow && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_style_es_js__WEBPACK_IMPORTED_MODULE_4__/* .StyledArrow */ .bC, {
    ref: arrowRef,
    style: __spreadValues({}, styles.arrow),
    className: (0,_utils_es_js__WEBPACK_IMPORTED_MODULE_5__/* .getArrowClassName */ .C)(attributes) || "",
    "data-placement": placement,
    backgroundColor: rest.backgroundColor
  }), typeof title === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_6__/* .SubTitle */ .DK, {
    level: 4,
    weight: "medium",
    color: "white"
  }, title) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(title, {
    style: __spreadValues({ color: "white" }, title == null ? void 0 : title.props)
  }), typeof content === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_6__/* .Body */ .uT, {
    level: 1,
    weight: "regular",
    color: "placeholder"
  }, content) : content ? react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(content, {
    style: __spreadValues({ color: "#A7ABC3" }, content == null ? void 0 : content.props)
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null), !!buttonText && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBottom, {
    buttonAlign
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButton, {
    variant: buttonVariant,
    size: "s",
    onClick: (e) => {
      e.stopPropagation();
      onClickButton == null ? void 0 : onClickButton();
    }
  }, buttonText))));
};




/***/ }),

/***/ 83574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Portal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(926759);



const generateId = () => `modal-${Math.random().toString(36).substring(7)}`;
const Portal = ({
  id,
  show,
  children,
  zIndex
}) => {
  const [elmRef, setElmRef] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  const [modalId, setModalId] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const elm = modalId ? document.getElementById(modalId) : null;
    if (!show) {
      if (elm) {
        setTimeout(() => {
          document.body.style.overflow = "";
          document.body.style.width = "";
          elm.style.display = "none";
        }, 200);
      }
      return;
    }
    if (elm) {
      document.body.style.overflow = "hidden";
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.width = `calc(100% - ${scrollbarWidth}px)`;
      elm.style.display = "flex";
      setElmRef(elm);
    } else {
      const elm2 = document.createElement("div");
      elm2.id = id || generateId();
      setModalId(elm2.id);
      elm2.style.position = "fixed";
      elm2.style.top = "0";
      elm2.style.left = "0";
      elm2.style.right = "0";
      elm2.style.bottom = "0";
      elm2.style.zIndex = (zIndex == null ? void 0 : zIndex.toString()) || "1050";
      elm2.style.justifyContent = "center";
      elm2.style.alignItems = "center";
      document.body.appendChild(elm2);
    }
  }, [show, modalId, id, zIndex]);
  if (!elmRef)
    return null;
  return react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(children, elmRef);
};




/***/ }),

/***/ 370345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ RadioGroup; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _Radio_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(245116);
/* harmony import */ var _Divider_Divider_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(329944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
`;
const RadioGroup = (_a) => {
  var _b = _a, {
    options,
    value,
    defaultValue,
    onChange,
    layout = "vertical",
    hasDivider = false
  } = _b, rest = __objRest(_b, [
    "options",
    "value",
    "defaultValue",
    "onChange",
    "layout",
    "hasDivider"
  ]);
  const showDivider = layout === "vertical" && hasDivider;
  const [initCheckedValue, setInitCheckedValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setInitCheckedValue(value === void 0 ? defaultValue : value);
  }, []);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, rest), options.map((opt, index, list) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    key: index
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperRadio, {
    layout,
    showDivider
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Radio_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Radio */ .Y, {
    key: opt.value,
    onClick: () => onChange && onChange(opt.value),
    checked: (value === void 0 ? initCheckedValue : value) === opt.value,
    disabled: opt == null ? void 0 : opt.disabled
  }, opt.label)), showDivider && index !== list.length - 1 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Divider_Divider_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Divider */ .i, {
    gap: 8,
    color: "#e0e0e0"
  }))));
};
const WrapperRadio = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ layout, showDivider }) => `
    display: ${layout === "vertical" ? "block" : "inline-flex"};
    margin-bottom: ${!showDivider ? "8px" : "unset"};
    margin-right: ${layout === "horizontal" ? "16px" : "unset"};
`);




/***/ }),

/***/ 134128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* harmony import */ var _Shape_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(425336);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);



const Skeleton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .Shape */ .b)`
  @keyframes loading {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  background-color: rgba(122, 121, 121, 0.11);
  -webkit-animation: loading 1.5s ease-in-out 0.5s infinite;
  animation: loading 1.5s ease-in-out 0.5s infinite;
  border-radius: 5px;
`;




/***/ }),

/***/ 89977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ Stepper; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Shape_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(425336);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(621655);
/* harmony import */ var _Flex_Flex_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(387100);





const Stepper = ({ steps, active }) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, steps.map((step) => {
    const isLast = step.index === steps.length - 1;
    const isActive = step.index === active;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Flex_Flex_es_js__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .k, {
      key: step.index,
      direction: "row",
      justify: "start"
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Flex_Flex_es_js__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .k, {
      justify: "center",
      align: "start",
      width: 9,
      paddingTop: "s4",
      style: {
        position: "relative",
        alignSelf: "stretch"
      }
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b, {
      backgroundColor: isActive ? "link" : "border",
      width: isActive ? 9 : 7,
      height: isActive ? 9 : 7,
      borderStyle: "solid",
      borderWeight: "l",
      borderColor: isActive ? "link200" : "border",
      style: { borderRadius: "50%", display: "inline-block" }
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b, {
      height: "calc(100% - 9px)",
      borderStyle: "solid",
      borderWeight: "m",
      borderRight: "0px",
      borderColor: "border",
      style: {
        visibility: steps.length > 1 && isLast ? "hidden" : "visible",
        position: "absolute",
        top: "13px",
        left: "4px"
      }
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b, {
      padding: ["s0", "s8"],
      paddingBottom: isLast ? "s0" : "s16"
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b, {
      marginBottom: "s4"
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, {
      color: isActive ? "link" : "black"
    }, step.title)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS, {
      color: "neutral",
      weight: "regular"
    }, step.subTitle)));
  }));
};




/***/ }),

/***/ 640793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ TabItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(846291);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledBody = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT)`
  &:hover {
    color: ${(p) => p.activeColor};
  }
`;
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding: ${(p) => `${p.theme.spacing.s8} ${p.theme.spacing.s16}`};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: ${(props) => props.minWidth ? props.minWidth : ""};
  max-width: ${(props) => props.maxWidth ? props.maxWidth : ""};
  background-color: ${(props) => props.isActive ? props.activeBackground : props.background};
  ${(p) => p.fluid ? `
    flex: 1;
  ` : ``}
  flex-direction: ${(p) => p.direction === "horizontal" ? "row" : "column"};
  ${(p) => !p.ignoreSecondChildStyles && `
      > *:nth-child(2) {
        ${p.direction === "horizontal" ? `
          flex: 1;
          margin-left: ${p.theme.spacing.s8};
        ` : `
          line-height: 1.5rem;
          margin-top: ${p.theme.spacing.s4};
        `}
      }
    `}
  &:hover {
    ${(props) => props.type === "line" ? `
      path[stroke],
      rect[stroke],
      line {
        stroke: ${props.theme.colors.primary500};
      }` : ""};
    path:not([stroke]),
    rect:not([stroke]) {
      fill: ${(p) => p.theme.colors.primary500};
    }
    > .tab-title {
      color: ${(p) => p.theme.colors.primary500};
    }
  }
`;
const TabItem = (_a) => {
  var _b = _a, {
    tabId,
    text,
    minWidth,
    maxWidth,
    icon,
    color = "textSecondary",
    activeColor = "primary500",
    background = "white",
    activeBackground = "white",
    direction = "horizontal",
    type,
    className,
    onClick,
    tabTitle
  } = _b, rest = __objRest(_b, [
    "tabId",
    "text",
    "minWidth",
    "maxWidth",
    "icon",
    "color",
    "activeColor",
    "background",
    "activeBackground",
    "direction",
    "type",
    "className",
    "onClick",
    "tabTitle"
  ]);
  const { activeTab, fluid, dispatch, onChange } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TabsContext */ .RL);
  const isActive = tabId === activeTab;
  const elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (elementRef.current && isActive) {
      onChange(tabId);
      dispatch({
        type: "setDimension",
        payload: {
          dimension: {
            width: elementRef.current.offsetWidth,
            left: elementRef.current.offsetLeft,
            height: elementRef.current.offsetHeight,
            top: elementRef.current.offsetTop
          }
        }
      });
    }
  }, [activeTab, dispatch]);
  const handleClick = () => {
    dispatch({ type: "changeTab", payload: { activeTab: tabId } });
    onClick == null ? void 0 : onClick();
    if (elementRef.current)
      elementRef.current.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "center"
      });
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    isActive,
    background,
    activeBackground,
    color,
    activeColor,
    ref: elementRef,
    onClick: handleClick,
    direction,
    fluid,
    type,
    className,
    minWidth,
    maxWidth,
    ignoreSecondChildStyles: !!tabTitle
  }, rest), icon ? react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(icon, {
    color: isActive ? activeColor : color
  }) : null, text ? isActive ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
    level: 4,
    color: activeColor,
    line: 1
  }, text) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBody, {
    level: 1,
    color,
    line: 1,
    activeColor
  }, text) : null, tabTitle && react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(tabTitle, {
    color: isActive ? activeColor : color
  }));
};




/***/ }),

/***/ 517844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ Tabs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(846291);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19840);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
  position: relative;
  height: 100%;
`;
const TabTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ width, left, theme, type }) => `
    position: relative;
    display: flex;
    align-items: stretch;
    overflow-x: scroll;
    overflow-y: hidden;
    width: 100%;
    ${type === "line" ? `border-bottom: 1px solid ${theme == null ? void 0 : theme.colors.divider};&::after {
      content: ' ';
      height: 2px;
      background-color: ${theme == null ? void 0 : theme.colors.primary500};
      display: inline-block;
      position: absolute;
      transition: all 0.2s ease-out;
      bottom: 0;
      left: ${left}px;
      width: ${width}px;
    }` : ""}
    /* Hide scroll bar */
    -ms-overflow-style: none;
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display: none;
    }


  `);
const Component = (_a) => {
  var _b = _a, {
    children,
    textActiveColor,
    textColor,
    background,
    activeBackground,
    type = "line",
    tabTitleProps
  } = _b, rest = __objRest(_b, [
    "children",
    "textActiveColor",
    "textColor",
    "background",
    "activeBackground",
    "type",
    "tabTitleProps"
  ]);
  var _a2, _b2;
  const {
    dimension: { width, left, top, height },
    activeTab
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TabsContext */ .RL);
  const arr = children.filter(_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_4__/* .isNotNullOrUndefinedElement */ .C4);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TabTitle, __spreadProps(__spreadValues({}, tabTitleProps), {
    type,
    width,
    left,
    top,
    height
  }), arr.map((item, index) => react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(item, {
    key: index,
    tabId: index,
    color: textColor,
    activeColor: textActiveColor,
    background,
    activeBackground,
    type
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, (_b2 = (_a2 = arr[activeTab]) == null ? void 0 : _a2.props) == null ? void 0 : _b2.children));
};
const withContext = (Component2) => {
  const Comp = (_a) => {
    var _b = _a, {
      fluid = false,
      children,
      defaultTab = 0,
      activeTab = defaultTab
    } = _b, rest = __objRest(_b, [
      "fluid",
      "children",
      "defaultTab",
      "activeTab"
    ]);
    const tabState = (0,_TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .useTabs */ .YE)(activeTab, fluid);
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TabsProvider */ .X, __spreadValues({}, tabState), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, __spreadValues({}, rest), children));
  };
  return Comp;
};
const Tabs = withContext(Component);




/***/ }),

/***/ 846291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RL": function() { return /* binding */ TabsContext; },
/* harmony export */   "X": function() { return /* binding */ TabsProvider; },
/* harmony export */   "YE": function() { return /* binding */ useTabs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultValue = {
  activeTab: 0,
  fluid: false,
  dimension: {
    left: 0,
    width: 0,
    top: 0,
    height: 0
  },
  dispatch: (_) => {
  },
  onChange: (_) => {
  }
};
const reducer = (state, action) => {
  var _a, _b;
  switch (action.type) {
    case "changeTab":
      return __spreadProps(__spreadValues({}, state), {
        activeTab: (_a = action.payload.activeTab) != null ? _a : state.activeTab
      });
    case "setDimension":
      return __spreadProps(__spreadValues({}, state), {
        dimension: (_b = action.payload.dimension) != null ? _b : state.dimension
      });
    default:
      return state;
  }
};
const useTabs = (defaultTab, fluid) => {
  const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(reducer, __spreadProps(__spreadValues({}, defaultValue), {
    fluid,
    activeTab: defaultTab
  }));
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    onChangeTab(defaultTab);
  }, [defaultTab]);
  const onChangeTab = (tabId) => {
    dispatch({ type: "changeTab", payload: { activeTab: tabId } });
  };
  return __spreadProps(__spreadValues({}, state), { onChange: onChangeTab, dispatch });
};
const TabsContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(defaultValue);
const TabsProvider = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TabsContext.Provider, {
    value: __spreadValues({}, props)
  }, children);
};




/***/ }),

/***/ 851373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ TextLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(621655);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(640128);
/* harmony import */ var _CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(618428);
/* harmony import */ var _configs_Colors_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(743126);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TextLink = (_a) => {
  var _b = _a, {
    href,
    children,
    hasColor = true,
    disabled = false,
    size = "m",
    prefixIcon,
    suffixIcon
  } = _b, rest = __objRest(_b, [
    "href",
    "children",
    "hasColor",
    "disabled",
    "size",
    "prefixIcon",
    "suffixIcon"
  ]);
  var _a2, _b2;
  const textColor = disabled ? _configs_Colors_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .themeColor.disable */ .E.disable : hasColor ? _configs_Colors_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .themeColor.link500 */ .E.link500 : _configs_Colors_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .themeColor.textSecondary */ .E.textSecondary;
  const Comp = size === "s" ? _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS : _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadValues({
    href: href || ""
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, null, prefixIcon && react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(prefixIcon, {
    size: ((_a2 = prefixIcon == null ? void 0 : prefixIcon.props) == null ? void 0 : _a2.size) || 16,
    color: textColor
  }), typeof children === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Comp, {
    level: 1,
    weight: "regular",
    color: textColor,
    hoverColor: "link600",
    style: { marginBottom: "3px" }
  }, children) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: { color: textColor },
    className: "text"
  }, children), suffixIcon && react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(suffixIcon, {
    size: ((_b2 = suffixIcon == null ? void 0 : suffixIcon.props) == null ? void 0 : _b2.size) || 16,
    color: textColor
  })));
};
const StyledLink = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_4__/* .CustomLink */ .x)`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .CommonStyles */ .F}
`;
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  display: flex;
  align-items: center;
  column-gap: 4px;
  width: max-content;
  &:hover {
    .text {
      color: ${_configs_Colors_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .themeColor.link600 */ .E.link600} !important;
    }
    path[stroke],
    rect[stroke],
    line {
      stroke: ${_configs_Colors_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .themeColor.link600 */ .E.link600};
    }
    path:not([stroke]),
    rect:not([stroke]) {
      fill: ${_configs_Colors_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .themeColor.link600 */ .E.link600};
    }
  }
`;




/***/ }),

/***/ 441363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Video; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19840);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Video = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, {
    width,
    height,
    controls,
    preload,
    autoPlay,
    playsInline,
    muted,
    src,
    className,
    tracking
  } = _a, others = __objRest(_a, [
    "width",
    "height",
    "controls",
    "preload",
    "autoPlay",
    "playsInline",
    "muted",
    "src",
    "className",
    "tracking"
  ]);
  const videoElement = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("video", __spreadValues({
    ref,
    width: width === "auto" ? width : "100%",
    height: height ? `${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .pixelParse */ .oJ)(height)}` : "100%",
    controls,
    preload,
    autoPlay,
    playsInline,
    muted
  }, others), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("track", {
    src: "captions_en.vtt",
    kind: "captions",
    label: "English",
    default: true
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    src,
    type: "video/mp4"
  }), "Your browser does not support the video tag.");
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, __spreadValues({
    height,
    width: width || "100%",
    className
  }, tracking), videoElement);
});
Video.displayName = "Video";
const Container = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ onClick, height, width }) => `
    position: relative;
    display: inline-block;
    overflow: hidden;
    ${onClick ? "cursor: pointer;" : ""}
    ${height ? `height: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .pixelParse */ .oJ)(height)};` : ""}
    ${width ? `width: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .pixelParse */ .oJ)(width)};` : "width: 100%;"}
  `);




/***/ }),

/***/ 55930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ YoutubeThumbnail; },
/* harmony export */   "T": function() { return /* binding */ YoutubeFrame; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Image_Image_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(587021);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const YoutubeFrame = (_a) => {
  var _b = _a, {
    embedId,
    youtubeLink,
    title,
    autoplay = 0
  } = _b, others = __objRest(_b, [
    "embedId",
    "youtubeLink",
    "title",
    "autoplay"
  ]);
  const videoEmbedId = youtubeLink ? getIdFromYoutubeLink(youtubeLink) : embedId;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("iframe", __spreadValues({
    src: `https://www.youtube.com/embed/${videoEmbedId}?autoplay=${autoplay}`,
    allowFullScreen: true,
    frameBorder: "0",
    title
  }, others));
};
const YoutubeThumbnail = (_c) => {
  var _d = _c, {
    embedId,
    youtubeLink,
    height,
    width
  } = _d, others = __objRest(_d, [
    "embedId",
    "youtubeLink",
    "height",
    "width"
  ]);
  const videoEmbedId = youtubeLink ? getIdFromYoutubeLink(youtubeLink) : embedId;
  const src = videoEmbedId ? `https://img.youtube.com/vi/${videoEmbedId}/0.jpg` : "";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Image_Image_es_js__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .E, __spreadProps(__spreadValues({}, others), {
    src,
    height,
    width
  }));
};
const getIdFromYoutubeLink = (url) => {
  var _a;
  if (!url)
    return "";
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?)|(shorts\/))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match && ((_a = match[match.length - 1]) == null ? void 0 : _a.length) === 11 ? match[match.length - 1] : "";
};




/***/ }),

/***/ 911884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qE": function() { return /* reexport */ Avatar_es/* Avatar */.q; },
  "zu": function() { return /* reexport */ BackToTop_es/* BackToTop */.z; },
  "Ct": function() { return /* reexport */ Badge_es/* Badge */.C; },
  "uT": function() { return /* reexport */ Typography_index_es/* Body */.uT; },
  "zx": function() { return /* reexport */ Button_es/* Button */.z; },
  "Ei": function() { return /* reexport */ ButtonIcon_es/* ButtonIcon */.E; },
  "yi": function() { return /* reexport */ index_es/* CORE_SIZE */.y; },
  "nq": function() { return /* reexport */ emotion_element_99289b21_browser_esm.C; },
  "YS": function() { return /* reexport */ Typography_index_es/* Caption */.YS; },
  "Zb": function() { return /* reexport */ Card_es/* Card */.Z; },
  "XZ": function() { return /* reexport */ Checkbox_es/* Checkbox */.X; },
  "Af": function() { return /* reexport */ Chip_es/* Chip */.A; },
  "JX": function() { return /* reexport */ Col_es/* Col */.JX; },
  "UO": function() { return /* reexport */ Collapse_es/* Collapse */.U; },
  "FS": function() { return /* reexport */ BaseProps_index_es/* CommonStyles */.F; },
  "W2": function() { return /* reexport */ Container_es/* Container */.W; },
  "F": function() { return /* reexport */ Currency_es/* Currency */.F; },
  "xb": function() { return /* reexport */ CustomLink_es/* CustomLink */.x; },
  "h7": function() { return /* reexport */ DeviceTypes; },
  "iz": function() { return /* reexport */ Divider_es/* Divider */.i; },
  "kC": function() { return /* reexport */ Flex_es/* Flex */.k; },
  "l0": function() { return /* reexport */ Form_index_es/* Form */.l; },
  "At": function() { return /* reexport */ Glide_es/* Glide */.A; },
  "xB": function() { return /* reexport */ emotion_react_browser_esm.Global; },
  "X6": function() { return /* reexport */ Typography_index_es/* Heading */.X6; },
  "Ee": function() { return /* reexport */ Image_es/* Image */.E; },
  "II": function() { return /* reexport */ Input_es/* Input */.I; },
  "Rn": function() { return /* reexport */ InputNumber_es/* InputNumber */.R; },
  "sN": function() { return /* reexport */ InputSlider_es/* InputSlider */.s; },
  "__": function() { return /* reexport */ Label_es/* Label */._; },
  "wY": function() { return /* reexport */ LazyImage_es/* LazyImage */.w; },
  "tz": function() { return /* reexport */ LegacyInput_es/* LegacyInput */.t; },
  "gb": function() { return /* reexport */ Loading_es/* Loading */.g; },
  "PK": function() { return /* reexport */ Loading_context_es/* LoadingProvider */.PK; },
  "vs": function() { return /* reexport */ index_es/* MAPPING_SIZE */.v; },
  "u_": function() { return /* reexport */ Modal_es/* Modal */.u; },
  "fe": function() { return /* reexport */ ModalBody_es/* ModalBody */.f; },
  "Su": function() { return /* reexport */ ModalCloseIcon; },
  "mz": function() { return /* reexport */ ModalFooter_es/* ModalFooter */.m; },
  "tQ": function() { return /* reexport */ ModalHeader_es/* ModalHeader */.x; },
  "Tp": function() { return /* reexport */ Draggable_es/* Movable */.T; },
  "W_": function() { return /* reexport */ navigation/* default */.Z; },
  "aV": function() { return /* reexport */ Overlay_es/* Overlay */.a; },
  "J2": function() { return /* reexport */ Popover_es/* Popover */.J; },
  "h_": function() { return /* reexport */ Portal_es/* Portal */.h; },
  "h0": function() { return /* reexport */ Quantity_es/* Quantity */.h; },
  "Y8": function() { return /* reexport */ Radio_es/* Radio */.Y; },
  "FX": function() { return /* reexport */ RadioGroup_es/* RadioGroup */.E; },
  "HW": function() { return /* reexport */ Ripple_es/* Ripple */.H; },
  "X2": function() { return /* reexport */ Row_es/* Row */.X; },
  "$0": function() { return /* reexport */ Section; },
  "qS": function() { return /* reexport */ SelectionButton; },
  "bn": function() { return /* reexport */ Shape_index_es/* Shape */.b; },
  "Od": function() { return /* reexport */ Skeleton_es/* Skeleton */.O; },
  "iR": function() { return /* reexport */ Slider; },
  "vF": function() { return /* reexport */ Stepper_es/* Stepper */.v; },
  "DK": function() { return /* reexport */ Typography_index_es/* SubTitle */.DK; },
  "tq": function() { return /* reexport */ swiper/* Swiper */.t; },
  "_2": function() { return /* reexport */ core_class/* default */.Z; },
  "o5": function() { return /* reexport */ swiper_slide/* SwiperSlide */.o; },
  "rs": function() { return /* reexport */ Switch_es/* Switch */.r; },
  "E2": function() { return /* reexport */ TabItem_es/* TabItem */.E; },
  "mQ": function() { return /* reexport */ Tabs_es/* Tabs */.m; },
  "Vp": function() { return /* reexport */ Tag_es/* Tag */.V; },
  "hh": function() { return /* reexport */ Textlink_es/* TextLink */.h; },
  "gx": function() { return /* reexport */ Textarea_es/* Textarea */.g; },
  "f6": function() { return /* reexport */ Theme_es/* ThemeProvider */.f; },
  "o3": function() { return /* reexport */ thumbs/* default */.Z; },
  "Dx": function() { return /* reexport */ Typography_index_es/* Title */.Dx; },
  "hX": function() { return /* reexport */ context_es/* ToastContextDesktop */.hX; },
  "gA": function() { return /* reexport */ mobile_context_es/* ToastContextMobile */.g; },
  "u": function() { return /* reexport */ Tooltip_es/* Tooltip */.u; },
  "nk": function() { return /* reexport */ Video_es/* Video */.n; },
  "Tu": function() { return /* reexport */ YoutubeIframe_es/* YoutubeFrame */.T; },
  "FN": function() { return /* reexport */ YoutubeIframe_es/* YoutubeThumbnail */.F; },
  "Gn": function() { return /* reexport */ helper_es/* constructGoogleImageParams */.Gn; },
  "Df": function() { return /* reexport */ emotion_cache_browser_esm["default"]; },
  "iv": function() { return /* reexport */ emotion_react_browser_esm.css; },
  "uH": function() { return /* reexport */ Theme_index_es/* defaultTheme */.u; },
  "XE": function() { return /* reexport */ Col_es/* floorPercentage */.XE; },
  "xG": function() { return /* reexport */ Currency_es/* formatCurrency */.xG; },
  "o0": function() { return /* reexport */ utils_es/* formatDateTime */.o0; },
  "R_": function() { return /* reexport */ generate_es/* default */.Z; },
  "I0": function() { return /* reexport */ utils_es/* generateTheme */.I0; },
  "CA": function() { return /* reexport */ Popover_utils_es/* getArrowClassName */.C; },
  "Fr": function() { return /* reexport */ BaseProps_index_es/* getDimension */.L; },
  "pW": function() { return /* reexport */ utils_es/* getElementOffset */.pW; },
  "Nc": function() { return /* reexport */ helper_es/* getImageUrlFromGoogleUserContent */.Nc; },
  "p": function() { return /* reexport */ util_es/* getRgbaFromHex */.p; },
  "np": function() { return /* reexport */ utils_es/* getScrollbarWidth */.np; },
  "XI": function() { return /* reexport */ helper_es/* imageLoader */.XI; },
  "iO": function() { return /* reexport */ isMobile; },
  "UA": function() { return /* reexport */ isMobileOnly; },
  "C4": function() { return /* reexport */ utils_es/* isNotNullOrUndefinedElement */.C4; },
  "c8": function() { return /* reexport */ utils_es/* mergeCls */.c8; },
  "CE": function() { return /* reexport */ utils_es/* omit */.CE; },
  "e9": function() { return /* reexport */ Col_es/* percentage */.e9; },
  "oJ": function() { return /* reexport */ utils_es/* pixelParse */.oJ; },
  "zo": function() { return /* reexport */ emotion_styled_browser_esm["default"]; },
  "EN": function() { return /* reexport */ Colors_index_es/* themeColor */.E; },
  "tk": function() { return /* reexport */ Currency_es/* thoundsandDelimiter */.tk; },
  "qo": function() { return /* reexport */ utils_es/* toArray */.qo; },
  "hQ": function() { return /* reexport */ utils_es/* uid */.hQ; },
  "O8": function() { return /* reexport */ utils_es/* useClickOutside */.O8; },
  "r$": function() { return /* reexport */ Loading_context_es/* useLoading */.r$; },
  "d$": function() { return /* reexport */ Loading_context_es/* useLoadingContext */.d$; },
  "dd": function() { return /* reexport */ hook_es/* useModal */.d; },
  "Fg": function() { return /* reexport */ Theme_es/* useTheme */.F; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/constants/index.es.js
var index_es = __webpack_require__(978719);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/configs/Colors/generate.es.js + 6 modules
var generate_es = __webpack_require__(380439);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/configs/Colors/util.es.js
var util_es = __webpack_require__(387948);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/configs/Colors/index.es.js
var Colors_index_es = __webpack_require__(743126);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/configs/Theme/index.es.js
var Theme_index_es = __webpack_require__(299406);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/contexts/Theme.es.js
var Theme_es = __webpack_require__(348855);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/helpers/utils.es.js
var utils_es = __webpack_require__(19840);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Toast/desktop/context.es.js + 1 modules
var context_es = __webpack_require__(92840);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Toast/mobile/context.es.js + 1 modules
var mobile_context_es = __webpack_require__(753625);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var BaseProps_index_es = __webpack_require__(640128);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Checkbox/Checkbox.es.js
var Checkbox_es = __webpack_require__(115869);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Radio/Radio.es.js
var Radio_es = __webpack_require__(245116);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Radio/RadioGroup.es.js
var RadioGroup_es = __webpack_require__(370345);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Switch/Switch.es.js
var Switch_es = __webpack_require__(71638);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/BackToTop/BackToTop.es.js
var BackToTop_es = __webpack_require__(879779);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Input/Input.es.js
var Input_es = __webpack_require__(725643);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Input/Textarea.es.js
var Textarea_es = __webpack_require__(209705);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/InputNumber/InputNumber.es.js + 11 modules
var InputNumber_es = __webpack_require__(97278);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Tabs/Tabs.es.js
var Tabs_es = __webpack_require__(517844);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Tabs/TabItem.es.js
var TabItem_es = __webpack_require__(640793);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Chip/Chip.es.js
var Chip_es = __webpack_require__(222056);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Tag/Tag.es.js
var Tag_es = __webpack_require__(991822);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Popover/Popover.es.js
var Popover_es = __webpack_require__(812809);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Popover/Tooltip.es.js
var Tooltip_es = __webpack_require__(386877);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Popover/utils.es.js
var Popover_utils_es = __webpack_require__(82389);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Badge/Badge.es.js
var Badge_es = __webpack_require__(613295);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Avatar/Avatar.es.js
var Avatar_es = __webpack_require__(703169);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Portal/Portal.es.js
var Portal_es = __webpack_require__(83574);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(982226);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Section/Section.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Section = react.forwardRef((props, ref) => {
  const _a = props, { children, fluid = false } = _a, others = __objRest(_a, ["children", "fluid"]);
  return /* @__PURE__ */ react.createElement(Container_es/* Container */.W, __spreadProps(__spreadValues({}, others), {
    fluid,
    ref
  }), /* @__PURE__ */ react.createElement(Row_es/* Row */.X, {
    gutter: [16, 16]
  }, children));
});
Section.displayName = "Section";



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Image/Image.es.js
var Image_es = __webpack_require__(587021);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Image/helper.es.js
var helper_es = __webpack_require__(990241);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Quantity/Quantity.es.js
var Quantity_es = __webpack_require__(280392);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(279215);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/components/navigation/navigation.js
var navigation = __webpack_require__(909221);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/components/pagination/pagination.js
var pagination = __webpack_require__(246626);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/components/autoplay/autoplay.js
var autoplay = __webpack_require__(13341);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/components/virtual/virtual.js
var virtual = __webpack_require__(955540);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Slider/helper.es.js
const renderPaginationStyle = (index, theme, paginationColor) => {
  const styleArr = [
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: ${theme.borderRadius.l};
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: ${theme.borderRadius.l};
      width: 24px;
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      background: #ddd;
      cursor: pointer;
      &:first-of-type {
        border-radius: 999px 0 0 999px;
      };
      &:last-of-type {
        border-radius: 0 999px 999px 0;
      }
    }
    .swiper-pagination-bullet-active {
      width: 24px;
      position: relative;
      &:after {
        content: "";
        border-radius: 999px;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${paginationColor};
      }
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: ${theme.borderRadius.l};
      width: 12px;
      height: 12px;
      border-radius: 50%;
      transform: translateY(2px);
    }`
  ];
  return index > 0 ? styleArr[index - 1] : "";
};
const renderSwipeButton = (index) => {
  const styleArr = [
    `.swiper-button-next {
      right: 0;
      left: auto;
      border-top-left-radius: 100px;
      border-bottom-left-radius: 100px;
      background-color: rgba(168, 168, 168, 0.46);
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
      background-color: rgba(168, 168, 168, 0.46);
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }`,
    `.swiper-button-next {
      right: 0;
      left: auto;
      border-radius: 50%;
      background-color: rgba(168, 168, 168, 0.46);
      margin-right: 0.5rem;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      border-radius: 50%;
      background-color: rgba(168, 168, 168, 0.46);
      margin-left: 1rem;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }`,
    `.swiper-button-next {
      right: 0;
      left: auto;
      background-color: transparent;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      background-color: transparent;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }`
  ];
  return index > 0 ? styleArr[index - 1] : null;
};



// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/react/swiper.js + 8 modules
var swiper = __webpack_require__(649713);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(418668);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Slider/Slider.es.js






var Slider_es_defProp = Object.defineProperty;
var Slider_es_defProps = Object.defineProperties;
var Slider_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Slider_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Slider_es_hasOwnProp = Object.prototype.hasOwnProperty;
var Slider_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var Slider_es_defNormalProp = (obj, key, value) => key in obj ? Slider_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Slider_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Slider_es_hasOwnProp.call(b, prop))
      Slider_es_defNormalProp(a, prop, b[prop]);
  if (Slider_es_getOwnPropSymbols)
    for (var prop of Slider_es_getOwnPropSymbols(b)) {
      if (Slider_es_propIsEnum.call(b, prop))
        Slider_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Slider_es_spreadProps = (a, b) => Slider_es_defProps(a, Slider_es_getOwnPropDescs(b));
var Slider_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Slider_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Slider_es_getOwnPropSymbols)
    for (var prop of Slider_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Slider_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
core_class/* default.use */.Z.use([navigation/* default */.Z, pagination/* default */.Z, autoplay/* default */.Z, virtual/* default */.Z]);
const Slider = (_a) => {
  var _b = _a, {
    className,
    children,
    paginationStyle,
    navigationStyle,
    speed = 3e3,
    pauseOnMouseEnter = true,
    paginationColor,
    virtual = true
  } = _b, swiperProps = Slider_es_objRest(_b, [
    "className",
    "children",
    "paginationStyle",
    "navigationStyle",
    "speed",
    "pauseOnMouseEnter",
    "paginationColor",
    "virtual"
  ]);
  const {
    slidesPerView,
    slidesPerGroup,
    slidesPerColumn,
    pagination,
    autoplay,
    loop
  } = swiperProps;
  const [swiperKey, setSwiperKey] = (0,react.useState)(0);
  const isMultipleRows = slidesPerColumn && slidesPerColumn > 1;
  if (pagination) {
    swiperProps.pagination = {
      clickable: true
    };
  }
  if (isMultipleRows)
    swiperProps.loop = false;
  if (autoplay) {
    swiperProps.autoplay = {
      delay: speed,
      disableOnInteraction: false,
      pauseOnMouseEnter
    };
  }
  if (!slidesPerGroup)
    swiperProps.slidesPerGroup = slidesPerView;
  (0,react.useEffect)(() => {
    setSwiperKey((key) => key + 1);
  }, [autoplay, loop, speed, pauseOnMouseEnter, virtual, slidesPerColumn]);
  return /* @__PURE__ */ react.createElement(Wrapper, {
    className,
    paginationStyle,
    navigationStyle,
    isMultipleRows: !!isMultipleRows,
    paginationColor
  }, /* @__PURE__ */ react.createElement(swiper/* Swiper */.t, Slider_es_spreadProps(Slider_es_spreadValues({
    key: `swiper-${swiperKey}`
  }, swiperProps), {
    slidesPerColumnFill: "row",
    resizeObserver: true,
    virtual: virtual ? {
      addSlidesBefore: slidesPerView
    } : false
  }), react.Children.map(children, (child, index) => /* @__PURE__ */ react.createElement(swiper_slide/* SwiperSlide */.o, {
    key: index,
    virtualIndex: index
  }, child))));
};
const Wrapper = emotion_styled_browser_esm["default"].div(({
  isMultipleRows,
  paginationStyle,
  paginationColor,
  navigationStyle,
  theme
}) => `
    .swiper-container {
      margin-left: auto;
      margin-right: auto;
      position: relative;
      overflow: hidden;
      list-style: none;
      padding: 0;
    }
    .swiper-wrapper {
      position: relative;
      height: 100%;
      display: flex;
      transition-property: transform;
      box-sizing: content-box;
      flex-wrap: ${isMultipleRows ? "wrap" : "nowrap"};
    }
    .swiper-slide {
      flex-shrink: 0;
      height: 100%;
      position: relative;
      transition-property: transform;
      ${isMultipleRows ? `margin-top: 0px !important` : ""};
    }
    &:hover {
      .swiper-button-next,
      .swiper-button-prev {
        opacity: 1;
        &.swiper-button-disabled {
          opacity: 0.35;
        }
      }
    }
    .swiper-pagination {
      position: absolute;
      text-align: center;
      transform: translate3d(0, 0, 0);
      z-index: 10;
    }
    .swiper-pagination-fraction {
      bottom: 0;
      left: 0;
      width: 100%;
    }
    .swiper-pagination-bullets {
      bottom: 10px;
      left: 0;
      width: 100%;
    }
    ${renderPaginationStyle(paginationStyle || 0, theme, paginationColor)};
    .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      top: 50%;
      z-index: 10;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      margin-top: -22px;
      opacity: 0;
      &.swiper-button-disabled {
        opacity: 0;
        cursor: auto;
        pointer-events: auto;
      }
    }
    ${renderSwipeButton(navigationStyle || 0)};
`);



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Divider/Divider.es.js
var Divider_es = __webpack_require__(329944);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(618428);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Ripple/Ripple.es.js
var Ripple_es = __webpack_require__(768384);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/hook.es.js
var hook_es = __webpack_require__(339674);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(411213);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalHeader.es.js
var ModalHeader_es = __webpack_require__(891256);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalBody.es.js
var ModalBody_es = __webpack_require__(309110);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalFooter.es.js
var ModalFooter_es = __webpack_require__(651337);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CloseOutlined.es.js
var CloseOutlined_es = __webpack_require__(676662);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalCloseIcon.es.js





const ModalCloseIcon = ({
  onHide,
  closeIcon = /* @__PURE__ */ react.createElement(CloseOutlined_es/* CloseOutlined */.X, {
    size: 32,
    color: "#000"
  }),
  className
}) => {
  return /* @__PURE__ */ react.createElement(CloseIconWrapper, {
    className,
    onClick: onHide
  }, closeIcon);
};
const CloseIconWrapper = emotion_styled_browser_esm["default"].div(({ size }) => `
  z-index: 1060;
  position: absolute;
  left: 100%;
  transform: translateX(-100%);
  min-width: ${(0,utils_es/* pixelParse */.oJ)(size || "") || "56px"};
  min-height: ${(0,utils_es/* pixelParse */.oJ)(size || "") || "56px"};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`);



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Overlay.es.js
var Overlay_es = __webpack_require__(92300);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Form/index.es.js + 23 modules
var Form_index_es = __webpack_require__(826373);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Currency/Currency.es.js
var Currency_es = __webpack_require__(853675);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Loading/Loading.es.js
var Loading_es = __webpack_require__(80912);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Loading/context.es.js
var Loading_context_es = __webpack_require__(106454);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/components/thumbs/thumbs.js
var thumbs = __webpack_require__(885525);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Card/Card.es.js
var Card_es = __webpack_require__(319326);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/contexts/SizeContext.es.js
var SizeContext_es = __webpack_require__(263008);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/SelectionButton/SelectionButton.es.js










var SelectionButton_es_defProp = Object.defineProperty;
var SelectionButton_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var SelectionButton_es_hasOwnProp = Object.prototype.hasOwnProperty;
var SelectionButton_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var SelectionButton_es_defNormalProp = (obj, key, value) => key in obj ? SelectionButton_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var SelectionButton_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (SelectionButton_es_hasOwnProp.call(b, prop))
      SelectionButton_es_defNormalProp(a, prop, b[prop]);
  if (SelectionButton_es_getOwnPropSymbols)
    for (var prop of SelectionButton_es_getOwnPropSymbols(b)) {
      if (SelectionButton_es_propIsEnum.call(b, prop))
        SelectionButton_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var SelectionButton_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (SelectionButton_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && SelectionButton_es_getOwnPropSymbols)
    for (var prop of SelectionButton_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && SelectionButton_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SelectionButton = (_a) => {
  var _b = _a, {
    isActive = false,
    size: customizeSize,
    prefix,
    suffix,
    content,
    isThumbnail = false,
    block,
    onClick,
    className
  } = _b, rest = SelectionButton_es_objRest(_b, [
    "isActive",
    "size",
    "prefix",
    "suffix",
    "content",
    "isThumbnail",
    "block",
    "onClick",
    "className"
  ]);
  var _a2, _b2;
  const size = react.useContext(SizeContext_es/* SizeContext */.X);
  const mergeSize = customizeSize || size || "m";
  const addonBefore = prefix ? /* @__PURE__ */ react.createElement(StyledShape, {
    height: index_es/* MAPPING_SIZE */.v[mergeSize]
  }, typeof prefix === "string" ? /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    level: 1,
    weight: "regular",
    className: "text",
    color: isActive ? "primary600" : "textSecondary"
  }, prefix) : react.cloneElement(prefix, {
    size: ((_a2 = prefix == null ? void 0 : prefix.props) == null ? void 0 : _a2.size) || 20,
    color: isActive ? Colors_index_es/* themeColor.primary600 */.E.primary600 : Colors_index_es/* themeColor.textSecondary */.E.textSecondary
  })) : null;
  const addonAfter = suffix ? /* @__PURE__ */ react.createElement(StyledShape, {
    height: index_es/* MAPPING_SIZE */.v[mergeSize]
  }, typeof suffix === "string" ? /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    level: 1,
    weight: "regular",
    className: "text",
    color: isActive ? "primary600" : "textSecondary"
  }, suffix) : react.cloneElement(suffix, {
    size: ((_b2 = suffix == null ? void 0 : suffix.props) == null ? void 0 : _b2.size) || 16,
    color: isActive ? Colors_index_es/* themeColor.primary600 */.E.primary600 : Colors_index_es/* themeColor.textSecondary */.E.textSecondary
  })) : null;
  return /* @__PURE__ */ react.createElement(SelectionButton_es_Wrapper, SelectionButton_es_spreadValues({
    onClick: () => onClick && onClick(),
    size: mergeSize,
    isActive,
    isThumbnail,
    block: !!block,
    className
  }, rest), addonBefore, isThumbnail ? /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
    src: content || "",
    contain: true,
    height: index_es/* MAPPING_SIZE */.v[mergeSize] - 10,
    width: index_es/* MAPPING_SIZE */.v[mergeSize] - 10
  }) : /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    level: 1,
    color: isActive ? "primary600" : "textPrimary",
    weight: "regular",
    style: { textAlign: "center", flex: 1 },
    className: "text"
  }, content), addonAfter);
};
const SelectionButton_es_Wrapper = emotion_styled_browser_esm["default"].div(BaseProps_index_es/* CommonStyles */.F, ({ size, isActive, isThumbnail, block, theme }) => `
    display: flex;
    align-items: center;
    column-gap: 8px;
    border-radius: 4px;
    cursor: pointer;
    height: ${index_es/* MAPPING_SIZE */.v[size]}px;
    border: 1px solid ${isActive ? theme.colors.primary500 : "#E4E5F0"};
    &:hover {
      ${!isActive ? `border-color: ${theme.colors.border};` : ""}
    }
    padding: ${isThumbnail ? "4px" : "0 12px"};
    width: ${block ? "100%" : "max-content"};
    .text {
      margin-bottom: 3px;
    }
`);
const StyledShape = (0,emotion_styled_browser_esm["default"])(Shape_index_es/* Shape */.b)`
  display: flex;
  align-items: center;
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Textlink/Textlink.es.js
var Textlink_es = __webpack_require__(851373);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/InputSlider/InputSlider.es.js
var InputSlider_es = __webpack_require__(603626);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/ButtonIcon/ButtonIcon.es.js
var ButtonIcon_es = __webpack_require__(993);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LegacyInput/LegacyInput.es.js
var LegacyInput_es = __webpack_require__(997195);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Glide/Glide.es.js + 1 modules
var Glide_es = __webpack_require__(349416);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Collapse/Collapse.es.js
var Collapse_es = __webpack_require__(952716);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Label/Label.es.js
var Label_es = __webpack_require__(126083);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Skeleton/Skeleton.es.js
var Skeleton_es = __webpack_require__(134128);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Stepper/Stepper.es.js
var Stepper_es = __webpack_require__(89977);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Draggable/Draggable.es.js
var Draggable_es = __webpack_require__(960340);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Video/Video.es.js
var Video_es = __webpack_require__(441363);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/YoutubeIframe/YoutubeIframe.es.js
var YoutubeIframe_es = __webpack_require__(55930);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-react-virtual-fce7dbd44e/0/cache/@emotion-react-npm-11.5.0-7e3b735976-4188b664cc.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(75537);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-react-virtual-fce7dbd44e/0/cache/@emotion-react-npm-11.5.0-7e3b735976-4188b664cc.zip/node_modules/@emotion/react/dist/emotion-element-99289b21.browser.esm.js + 1 modules
var emotion_element_99289b21_browser_esm = __webpack_require__(962470);
// EXTERNAL MODULE: ../../.yarn/cache/@emotion-cache-npm-11.5.0-713285e054-8b3fac281e.zip/node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(926854);
// EXTERNAL MODULE: ../../.yarn/cache/ua-parser-js-npm-0.7.30-2c19d716f9-19aad6e1b9.zip/node_modules/ua-parser-js/src/ua-parser.js
var ua_parser = __webpack_require__(268489);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/libs/ua-parser-js.es.js


const DeviceTypes = {
  Mobile: "mobile",
  Tablet: "tablet",
  SmartTv: "smarttv",
  Console: "console",
  Wearable: "wearable",
  Browser: void 0
};
const UA = new ua_parser.UAParser();
const device = UA.getDevice();
const isMobileType = () => device.type === DeviceTypes.Mobile;
const isMobileAndTabletType = () => {
  switch (device.type) {
    case DeviceTypes.Mobile:
    case DeviceTypes.Tablet:
      return true;
    default:
      return false;
  }
};
const isMobileOnly = isMobileType();
const isMobile = isMobileAndTabletType();



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/index.es.js













































































/***/ }),

/***/ 96121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ArrowDownTinyFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ArrowDownTinyFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M18.8747 7.5H5.12475C5.01092 7.50004 4.89927 7.52494 4.80184 7.57203C4.70441 7.61911 4.6249 7.68659 4.5719 7.76718C4.51889 7.84777 4.4944 7.93841 4.50107 8.02932C4.50774 8.12023 4.54532 8.20795 4.60975 8.28303L11.4847 16.2833C11.5422 16.3501 11.6191 16.4048 11.7088 16.4425C11.7985 16.4803 11.8984 16.5 11.9997 16.5C12.1011 16.5 12.201 16.4803 12.2907 16.4425C12.3804 16.4048 12.4573 16.3501 12.5147 16.2833L19.3897 8.28303C19.4542 8.20795 19.4917 8.12023 19.4984 8.02932C19.5051 7.93841 19.4806 7.84777 19.4276 7.76718C19.3746 7.68659 19.2951 7.61911 19.1977 7.57203C19.1002 7.52494 18.9886 7.50004 18.8747 7.5Z",
              fill: "#82869E"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0" },
            child: [
              {
                tag: "rect",
                attr: {
                  width: "15",
                  height: "15",
                  fill: "white",
                  transform: "translate(4.5 4.5)"
                }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 839746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ CalendarOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const CalendarOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.9674 4.43457C17.9674 4.02036 17.6316 3.68457 17.2174 3.68457C16.8032 3.68457 16.4674 4.02036 16.4674 4.43457V5H7.53261V4.43457C7.53261 4.02036 7.19682 3.68457 6.78261 3.68457C6.36839 3.68457 6.03261 4.02036 6.03261 4.43457V5H4.75C3.23122 5 2 6.23122 2 7.75V18.25C2 19.7688 3.23122 21 4.75 21H19.25C20.7688 21 22 19.7688 22 18.25V7.75C22 6.23122 20.7688 5 19.25 5H17.9674V4.43457ZM6.03261 6.5H4.75C4.05964 6.5 3.5 7.05964 3.5 7.75V9.25H20.5V7.75C20.5 7.05964 19.9404 6.5 19.25 6.5H17.9674V7.04327C17.9674 7.45748 17.6316 7.79327 17.2174 7.79327C16.8032 7.79327 16.4674 7.45748 16.4674 7.04327V6.5H7.53261V7.04327C7.53261 7.45748 7.19682 7.79327 6.78261 7.79327C6.36839 7.79327 6.03261 7.45748 6.03261 7.04327V6.5ZM3.5 10.75H20.5V18.25C20.5 18.9404 19.9404 19.5 19.25 19.5H4.75C4.05964 19.5 3.5 18.9404 3.5 18.25V10.75Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 753954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ ClockAlternativeOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ClockAlternativeOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.4924 14.25C16.9066 14.2541 17.2458 13.9218 17.25 13.5076C17.2541 13.0934 16.9218 12.7542 16.5076 12.75L13.9874 12.7246C13.302 12.7177 12.75 12.1601 12.75 11.4746V8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8V11.4746C11.25 12.9826 12.4644 14.2093 13.9722 14.2245L16.4924 14.25Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 622746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ForwardOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ForwardOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M8.5 19L15.5 12L8.5 5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 707536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ JumpBackOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const JumpBackOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.7803 5.53033C13.0732 5.23744 13.0732 4.76256 12.7803 4.46967C12.4874 4.17678 12.0126 4.17678 11.7197 4.46967L4.71967 11.4697C4.42678 11.7626 4.42678 12.2374 4.71967 12.5303L11.7197 19.5303C12.0126 19.8232 12.4874 19.8232 12.7803 19.5303C13.0732 19.2374 13.0732 18.7626 12.7803 18.4697L6.31066 12L12.7803 5.53033ZM18.7803 5.53033C19.0732 5.23744 19.0732 4.76256 18.7803 4.46967C18.4874 4.17678 18.0126 4.17678 17.7197 4.46967L10.7197 11.4697C10.4268 11.7626 10.4268 12.2374 10.7197 12.5303L17.7197 19.5303C18.0126 19.8232 18.4874 19.8232 18.7803 19.5303C19.0732 19.2374 19.0732 18.7626 18.7803 18.4697L12.3107 12L18.7803 5.53033Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 887881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ JumpForwardOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const JumpForwardOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.21967 18.7197C4.92678 19.0126 4.92678 19.4874 5.21967 19.7803C5.51256 20.0732 5.98744 20.0732 6.28033 19.7803L13.2803 12.7803C13.5732 12.4874 13.5732 12.0126 13.2803 11.7197L6.28033 4.71967C5.98744 4.42678 5.51256 4.42678 5.21967 4.71967C4.92678 5.01256 4.92678 5.48744 5.21967 5.78033L11.6893 12.25L5.21967 18.7197ZM11.2197 18.7197C10.9268 19.0126 10.9268 19.4874 11.2197 19.7803C11.5126 20.0732 11.9874 20.0732 12.2803 19.7803L19.2803 12.7803C19.5732 12.4874 19.5732 12.0126 19.2803 11.7197L12.2803 4.71967C11.9874 4.42678 11.5126 4.42678 11.2197 4.71967C10.9268 5.01256 10.9268 5.48744 11.2197 5.78033L17.6893 12.25L11.2197 18.7197Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 944912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ hasColoredIcon; }
/* harmony export */ });
const hasColoredIcon = (ele) => {
  var _a, _b;
  if (!ele)
    return false;
  return (_b = (_a = ele == null ? void 0 : ele.type) == null ? void 0 : _a.name) == null ? void 0 : _b.endsWith("Colored");
};




/***/ })

}]);